import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	buttonContainer: {
		display: 'flex',
		justifyContent: 'space-around',
		width: 200,
	},
	checkboxContainer: {
		margin: '0 0 20px',
	},
	container: {
		boxSizing: 'border-box',
		margin: '20px 0',
		overflow: 'hidden',
	},
	googleBusinessItem: {
		...CssSelectors.allChildren({
			marginBottom: 6,
		}),
	},
	item: {
		height: 200,
		marginLeft: 15,
		marginTop: 15,
		width: 300,
	},
	itemIcon: {
		height: 55,
		maxWidth: '100%',
	},
	itemIconLarge: {
		height: 'auto',
		maxHeight: 65,
		maxWidth: '100%',
		minHeight: 55,
	},
	items: {
		display: 'flex',
		flexWrap: 'wrap',
		marginLeft: -15,
		marginTop: -15,
	},
	textLogo: {
		color: brandPrimaryText,
		fontSize: 24,
		lineHeight: 1.01,
	},
});
